import React from 'react';
import PropTypes from 'prop-types';
import './style.less';
import _ from 'lodash';
import { Checkbox, FormControlLabel, Tooltip } from '@material-ui/core';

export const CheckboxList = (props) => {
  const [state, setState] = React.useState(props.value?.split('|') || []);

  const handleChange = (event, name) => {
    let values = state;
    if (event.target.checked) {
      if (values.find(x => x === event.target.name) === undefined) {
        values.push(event.target.name);
      }
    } else {
      values = values.filter(x => x !== event.target.name);
    }
    setState(values);
    props.onChange && props.onChange(values.join('|'));
  };

  return (
    <>
      <div className="row margin-left10">

        {(((props || {}).sourceData || {}).source || []).map((x, i) =>
          (
          <div className="col-xs-auto col-sm-6 col-lg-4 no-padding" key={'col_' + i}>
            <FormControlLabel
              disabled={props.isEditable}
              key={'checkbox_' + i}
              value={state.find(op => op === x[props?.sourceData?.option])}
              control={
                <Checkbox
                  disabled={props.isEditable}
                  color="primary"
                  checked={state.find(op => op === x[props?.sourceData?.option])}
                  onChange={(event) => { handleChange(event, x[props?.sourceData?.option]); }}
                  name={x[props?.sourceData?.option]}
                />
              }
              className={'small-text'}
              label={x[props.sourceData.option]}
              labelPlacement="end"
            />
          </div>
          )
        )}
      </div>
    </>
  );
};
